import { render, staticRenderFns } from "./ThumbnailFixGenerator.vue?vue&type=template&id=8c870374&scoped=true"
import script from "./ThumbnailFixGenerator.vue?vue&type=script&lang=ts"
export * from "./ThumbnailFixGenerator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c870374",
  null
  
)

export default component.exports